import { render, staticRenderFns } from "./playPoint.vue?vue&type=template&id=4bb2b716&scoped=true&"
import script from "./playPoint.vue?vue&type=script&lang=js&"
export * from "./playPoint.vue?vue&type=script&lang=js&"
import style0 from "./playPoint.vue?vue&type=style&index=0&id=4bb2b716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2b716",
  null
  
)

export default component.exports